import cn from 'classnames';

import TextField from '@guestyci/foundation/TextField';
import { Text } from '@guestyci/arc';
import createStyles from '@guestyci/foundation/createStyles';
import useFeatureToggle from '@guestyci/feature-toggle-fe/useFeatureToggle';

import PriceConverter from 'components/PriceConverter';
import { ODS_ACCESSIBILITY_HTML } from 'constants/featureToggleNames';

const useStyles = createStyles(() => ({
  originalPrice: {
    textDecoration: 'line-through',
  },
}));

const OriginalPrice = ({ money = {}, className, roundPrice }) => {
  const [, isAccessibilityHtml] = useFeatureToggle(ODS_ACCESSIBILITY_HTML);
  const { originalPrice } = useStyles();
  const { fareAccommodation, currency } = money;

  return !isAccessibilityHtml
  ? (
    <TextField data-qa="subtotal-price" className={cn(className, originalPrice)} color="light">
      <PriceConverter roundPrice={roundPrice} amount={fareAccommodation} currency={currency} />
    </TextField>
  )
  : (
    <Text data-qa="subtotal-price" className={cn('gst-text-muted-foreground', className, originalPrice)}>
      <PriceConverter roundPrice={roundPrice} amount={fareAccommodation} currency={currency} />
    </Text>
  );
};

export default OriginalPrice;
